export const departmentOptions = [
    {value: 'Executive', label: 'Executive'},
    {value: 'Accounting', label: 'Accounting'},
    {value: 'Sales', label: 'Sales'},
    {value: 'Cultivation', label: 'Cultivation'},
    {value: 'Fulfillment', label: 'Fulfillment'},
    {value: 'Nursery', label: 'Nursery'},
    {value: 'Delivery', label: 'Delivery'},
    {value: 'TrapconRetailNordhoff', label: 'TrapconRetailNordhoff'},
    {value: 'Retail2', label: 'Retail2'},
    {value: 'Retail3', label: 'Retail3'},
    {value: 'Manufacturing', label: 'Manufacturing'},
    {value: 'Distro', label: 'Distro'},
    {value: 'Graphics', label: 'Graphics'},
    {value: 'Operations', label: 'Operations' },
    {value: 'SocialMedia', label: 'SocialMedia'},
    {value: 'OutsideSales', label: 'OutsideSales'},
];